import { React, useState } from 'react'
import { Link } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import Sidebar from './Sidebar';


const AddProject = () => {

  const [isOpen, setOpen] = useState(false);
  // const [isClose, setClose] = useState(false);
  const toggleOpen = () => {
    setOpen(!isOpen);
  };
  return (
    <>
      <div className="dashboard">
        <div className={isOpen ? 'd-flex toggled' : 'd-flex'} id="wrapper">
          <Sidebar />
          <div className="page-content">
            <nav className="navbar navbar-expand-lg navbar-light bg-transparent">
              <div className="d-flex align-items-center py-3 ps-3 d-lg-none">
                <Link onClick={toggleOpen} role="button"><i className="fas  fa-align-left primary-text fs-4 me-3" id="menu-toggle"></i></Link>

              </div>
              <AdminHeader />
            </nav>
            {/* <!-- Areas --> */}
            <div className="dashboard-page p-4">
              {/* contact form starts*/}
              <div className="contact dashboard-form">
                <div className="container">


                  <div className="contact-area">
                    <form action="">
                      <div className="row">

                        <div className="col-lg-6 mb-5 mb-lg-0">

                          <div className="contact-form">

                            <div className="mb-4">
                              <label>Name</label>
                              <input type="text" placeholder="Enter name" />
                            </div>
                            <div className="mb-4">
                              <label>Country</label>
                              <select className="form-select" aria-label="Default select example">
                                <option selected>Select Country</option>
                                <option value="India">India</option>
                                <option value="Australia">Australia</option>
                                <option value="Usa">USA</option>
                              </select>
                            </div>
                            <div className="mb-4">
                              <label>State/Province</label>
                              <select className="form-select" aria-label="Default select example">
                                <option selected>Select State</option>
                                <option value="1">Maharashtra</option>
                                <option value="2">Madhya Pradesh</option>
                                <option value="3">Rajasthan</option>
                              </select>
                            </div>
                            <div className="mb-4">
                              <label>Yeild</label>
                              <input type="text" placeholder="Enter Yeild" />
                            </div>
                            <div className="mb-4">
                              <label>Return Target</label>
                              <input type="text" placeholder="Enter Return Target" />
                            </div>

                            {/* <div className="send-button">
                              <button>Send</button>
                            </div> */}

                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="contact-form">

                            <div className="mb-4">
                              <label>Address</label>
                              <input type="text" placeholder="Enter Address" />
                            </div>
                            <div className="mb-4">
                              <label>City</label>
                              <input type="text" placeholder="Enter City" />
                            </div>
                            <div className="mb-4">
                              <label>Zip/Postal Code</label>
                              <input type="text" placeholder="Enter Code" />
                            </div>
                            <div className="mb-4">
                              <label>Lease Period</label>
                              <input type="text" placeholder="Enter Lease Period" />
                            </div>
                            <div className="mb-4">
                              <label>Lock in Period</label>
                              <input type="text" placeholder="Enter Period" />
                            </div>

                            {/* <div className="send-button">
  <button>Send</button>
</div> */}

                          </div>
                        </div>

                      </div>
                      <div className="next-button text-end">
                        <Link to="/project-save"><button>Next</button></Link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* contact form ends */}
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default AddProject